/**
 * 全局进入可视区域动画
 * 使用方法：给任何元素添加 'view-animate' 类名
 * 效果：进入可视区域时透明度从0.7变为1，位置从translateY(-20px)变为translateY(0)
 */
// <!-- 从下往上的基本动画 -->
// <div class="view-animate">我会从下方滑入</div>

// <!-- 不同强度 -->
// <div class="view-animate subtle">轻微从下滑入 (10px)</div>
// <div class="view-animate">默认从下滑入 (20px)</div>
// <div class="view-animate strong">强烈从下滑入 (40px)</div>

// <!-- 配合延时 -->
// <div class="view-animate delay-200">延时从下滑入</div>


(function() {
  'use strict';

  // 配置常量
  const CONFIG = {
    CLASS_NAME: 'view-animate',           // 触发动画的类名
    ANIMATED_CLASS: 'view-animated',      // 动画激活时添加的类名
    THRESHOLD: 0.2,                      // 可视区域阈值
    ROOT_MARGIN: '0px 0px -50px 0px',    // 提前触发区域
    ANIMATION_DURATION: '0.8s',          // 动画持续时间
    ANIMATION_EASING: 'cubic-bezier(0.4, 0, 0.2, 1)' // 动画缓动函数
  };

  // 防止重复初始化
  if (window.viewAnimationInitialized) {
    return;
  }
  window.viewAnimationInitialized = true;

  // 创建全局CSS样式
  function createGlobalStyles() {
    const styleId = 'view-animation-styles';
    
    // 检查是否已存在样式
    if (document.getElementById(styleId)) {
      return;
    }

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      /* 全局进入可视区域动画样式 */
      .${CONFIG.CLASS_NAME} {
        opacity: 0.7;
        transform: translateY(20px);
        transition: opacity ${CONFIG.ANIMATION_DURATION} ${CONFIG.ANIMATION_EASING},
                    transform ${CONFIG.ANIMATION_DURATION} ${CONFIG.ANIMATION_EASING};
        will-change: opacity, transform;
      }

      .${CONFIG.CLASS_NAME}.${CONFIG.ANIMATED_CLASS} {
        opacity: 1;
        transform: translateY(0);
      }

      /* 可选的延时动画类 */
      .${CONFIG.CLASS_NAME}.delay-100 {
        transition-delay: 0.1s;
      }
      
      .${CONFIG.CLASS_NAME}.delay-200 {
        transition-delay: 0.2s;
      }
      
      .${CONFIG.CLASS_NAME}.delay-300 {
        transition-delay: 0.3s;
      }
      
      .${CONFIG.CLASS_NAME}.delay-400 {
        transition-delay: 0.4s;
      }

      /* 可选的不同动画强度 */
      .${CONFIG.CLASS_NAME}.strong {
        transform: translateY(40px);
      }
      
      .${CONFIG.CLASS_NAME}.subtle {
        transform: translateY(10px);
      }
    `;

    document.head.appendChild(style);
  }

  // 创建 Intersection Observer
  function createObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const element = entry.target;
        
        if (entry.isIntersecting) {
          // 进入可视区域，添加动画类
          element.classList.add(CONFIG.ANIMATED_CLASS);
        } else {
          // 离开可视区域，移除动画类（执行反向动画）
          element.classList.remove(CONFIG.ANIMATED_CLASS);
        }
      });
    }, {
      threshold: CONFIG.THRESHOLD,
      rootMargin: CONFIG.ROOT_MARGIN
    });

    return observer;
  }

  // 初始化动画
  function initViewAnimation() {
    // 创建全局样式
    createGlobalStyles();

    // 创建观察器
    const observer = createObserver();

    // 观察所有已存在的动画元素
    function observeElements() {
      const elements = document.querySelectorAll(`.${CONFIG.CLASS_NAME}`);
      elements.forEach(element => {
        observer.observe(element);
      });
    }

    // 初始观察
    observeElements();

    // 监听DOM变化，自动观察新添加的元素
    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) { // 元素节点
            // 检查新添加的元素本身
            if (node.classList && node.classList.contains(CONFIG.CLASS_NAME)) {
              observer.observe(node);
            }
            
            // 检查新添加元素的子元素
            const childElements = node.querySelectorAll ? node.querySelectorAll(`.${CONFIG.CLASS_NAME}`) : [];
            childElements.forEach(child => {
              observer.observe(child);
            });
          }
        });
      });
    });

    // 开始监听DOM变化
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    // 页面卸载时清理
    window.addEventListener('beforeunload', () => {
      observer.disconnect();
      mutationObserver.disconnect();
    });

    // 暴露到全局，方便手动控制
    window.viewAnimation = {
      observer: observer,
      mutationObserver: mutationObserver,
      config: CONFIG,
      refresh: observeElements
    };
  }

  // DOM加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initViewAnimation);
  } else {
    initViewAnimation();
  }

})(); 